import React from 'react'
import LoginLayoutPP from "../login/LoginLayoutPP";
import { ClientLogo } from "@cxagroup/casper";
import LogoPP from "../common/LogoPP";
import messages from "components/messagesDescription";
import { passwordReset } from "actions/passwordResetActions";
import PasswordResetForm from "./PasswordResetForm";
import { injectIntl, intlShape } from "react-intl";
import { fetchPasswordPolicy } from "actions/changePasswordActions";
import { clean } from "actions/forgotPasswordActions";
import { camelizeKeys } from "humps";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import lodash from "lodash";
import { useSelector, useDispatch} from "react-redux";

const PasswordResetPagePP = (props) => {
    const { client, logoUrl, passwordReset, intl } = props;
    const policyDescription = useSelector(state => state.changePassword.policyDescription)
    const clientName = useSelector(state => state.app.clientName)

    const doRedirect = () => {
        const {
          user,
          isAuthenticated,
          push,
          query: { redirectTo },
        } = props;
        if (isAuthenticated) {
          const nextLocation = redirectTo
            ? decodeURI(redirectTo)
            : lodash.get(user, "websiteConfig.portal");
          if (nextLocation) {
            push(nextLocation);
          }
        }
      };

      const dispatch = useDispatch()
      React.useEffect(() => {
        if(clientName){
          dispatch(fetchPasswordPolicy({ clientName }));
        }
        return () => {
          dispatch(clean());
        };
      }, [clientName, fetchPasswordPolicy, clean]);
    
   
    React.useEffect(() => {
        doRedirect();
    }, []);
      
  return (
    <LoginLayoutPP isFlex={true}>
      <div className="login__brand" style={{ width: "100%" }}>
        {logoUrl ? <ClientLogo client={client} logoUrl={logoUrl} size="large" /> : <LogoPP width={240}/>}
      </div>
      <h3>{intl.formatMessage(messages.passwordResetDescription)}</h3>
      <section>
          <p>{intl.formatMessage(messages.passwordReset.passwordResetMessage)}</p>
      </section>
      <div className="form-container">
      <PasswordResetForm onSubmit={passwordReset} policyDescription={policyDescription} {...props} />
      </div>
    </LoginLayoutPP>
  )
}

PasswordResetPagePP.propTypes = {
    client: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    logoUrl: PropTypes.string,
    passwordReset: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    user: PropTypes.object,
    query: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    intl: intlShape.isRequired,
  };
  
  const mapStateToProps = (
    {
      app: { client, clientName },
      passwordReset: { response, submitting, submitted },
      changePassword: { policyDescription },
      common: { logoUrl },
    },
    { query }
  ) => {
    const camelizeQuery = camelizeKeys(query);
    return {
      client,
      logoUrl,
      response,
      submitting,
      submitted,
      policyDescription,
      initialValues: {
        companyId: camelizeQuery.clientID,
        requestToken: camelizeQuery.token,
      },
    };
  };

const mapDispatchToProps = (dispatch) => ({
passwordReset: (data, intl) => dispatch(passwordReset(data, intl)),
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PasswordResetPagePP)
);



// WEBPACK FOOTER //
// ./components/password/PasswordResetPagePP.js